module.exports = __webpack_public_path__ + "img/user_avatar_bg.51542a42.png";